;(() => {
  const $globalNav = document.querySelector('#global-nav')
  if ($globalNav) {
    $globalNav.addEventListener('change', event => {
      if (event.target.checked) {
        document.body.classList.add('no-scroll')
      } else {
        document.body.classList.remove('no-scroll')
      }
    })
  }
})()
